import React, {Component} from 'react';
import MultiClamp from 'react-multi-clamp';
import {connect} from 'react-redux';

import ProfileAvatar from 'components/ProfileAvatar';
import ProfileLink from 'components/ProfileLink';
import GenderIcon from 'components/GenderIcon';
import { Link } from 'components/ReactRouterDomLocalized';

import {formatLocation, getAgeText, getGenderText, getStatusText} from 'utils/user';
import {t} from 'l10n';

const ORDER_NICK = 'nick';
const ORDER_AGE = 'age';
const ORDER_GENDER = 'gender';
const ORDER_ONLINE = 'status';

import {unfollowProfile} from 'reducers/member';
import queryString from "query-string";

class FollowersList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {
        let {list, actionButton, unfollowProfile} = this.props;

        return (
            <table>
                <thead>
                <tr>
                    <th className="avatar"/>
                    <th className="gender"><OrderLink order={ORDER_GENDER} props={this.props}>{t('Gender')}</OrderLink></th>
                    <th><OrderLink order={ORDER_NICK} props={this.props}>{t('Nick')}</OrderLink></th>
                    <th><OrderLink order={ORDER_ONLINE} props={this.props}>{t('Room')}</OrderLink></th>
                    <th><OrderLink order={ORDER_AGE} props={this.props}>{t('Age')}</OrderLink></th>
                    <th>{t('Location')}</th>
                    {actionButton && <th/>}
                </tr>
                </thead>
                <tbody>
                {list.map((user) =>
                    <tr key={user.id}>
                        <td className="avatar">
                            <ProfileAvatar user={user}/>
                            <ProfileAvatar user={user} big/>
                        </td>
                        <td className="gender"><GenderIcon user={user}/></td>
                        <td className="nick"><GenderIcon user={user}/> <ProfileLink user={user}/></td>
                        <td className="status">{user.online ? <Link to={user.room.url} onClick={(e) => openRoom(e, user.room)} className="room-link">{user.room.name}</Link> : t('offline')}</td>
                        <td className="age">{getAgeText(user)}</td>
                        <td className="location">
                            <MultiClamp clamp="2">{formatLocation(user)}</MultiClamp>
                        </td>
                        {actionButton &&
                            <td className="action">
                                <a onClick={() => unfollowProfile(user.id)} className="ui-button">{t('Unfollow')}</a>
                            </td>
                        }
                    </tr>
                )}
                </tbody>
            </table>
        )
    }
}

function openRoom(e, room) {
    e.preventDefault();

    window.open(room.url, 'chat', 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');
}

function OrderLink({children, order, props, className}) {
    const newState = {};

    let classNames = ['order', className];

    if (order === props.order) {
        classNames.push('selected');
        if (props.desc) classNames.push('desc');

        newState.desc = props.desc == 0 ? 1 : 0;

    } else {
        newState.desc = 0;
    }

    //return <a className={classNames.join(' ')} onClick={() => setState(newState)}>{children}</a>
    return <Link to={{
            pathname: props.pathname,
            search: queryString.stringify({page: props.page, order: order, desc: newState.desc ? 1:0})
        }} className={classNames.join(' ')}  >{children}</Link>
}

export default connect(
    null,
    {
        unfollowProfile: unfollowProfile
    }
)(FollowersList);


// WEBPACK FOOTER //
// ./src/containers/member/follow/FollowersList.js